import React from 'react';
import { formatPrice, formatUnitPrice } from '../../utils/priceFormatter';

const FabricCalculationDisplay = ({
  fabricCalculation,
  detailCalculAvancee,
  showDetailCalcul,
  setShowDetailCalcul,
  isPergola,
  optionsSupp,
  nombreSanglons,
  sanglonUnitPrice,
  calculationError
}) => {
  if (calculationError) {
    return (
      <div className="mt-4 p-3 bg-red-50 rounded border border-red-200">
        <p className="text-sm text-red-600">{calculationError}</p>
      </div>
    );
  }

  if (!fabricCalculation) return null;

  return (
    <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <h4 className="text-sm font-semibold text-blue-900 mb-3">Récapitulatif de confection</h4>
      <div className="bg-white p-3 rounded border border-blue-100 text-center">
        <p className="text-lg font-mono font-bold text-gray-900">{fabricCalculation.display}</p>
        <p className="text-xs text-gray-500 mt-2">
          Largeur totale | Avancée totale | Nombre de laizes | Métrage total | Poids total
        </p>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
        <div className="bg-white p-2 rounded">
          <span className="text-gray-600">Largeur totale:</span>
          <span className="font-medium ml-1">{fabricCalculation.largeur_totale} cm</span>
        </div>
        <div className="bg-white p-2 rounded">
          <span className="text-gray-600">Avancée totale:</span>
          <span className="font-medium ml-1">{fabricCalculation.avancee_totale} cm</span>
        </div>
        <div className="bg-white p-2 rounded">
          <span className="text-gray-600">Nombre de laizes:</span>
          <span className="font-medium ml-1">{fabricCalculation.nombre_laizes}</span>
        </div>
        <div className="bg-white p-2 rounded">
          <span className="text-gray-600">Métrage total:</span>
          <span className="font-medium ml-1">{fabricCalculation.metrage_total} m</span>
        </div>
        <div className="bg-white p-2 rounded col-span-2">
          <span className="text-gray-600">Poids total:</span>
          <span className="font-medium ml-1">{fabricCalculation.poids_total} g</span>
        </div>
      </div>
      
      {/* Détail du calcul de l'avancée */}
      {detailCalculAvancee && (
        <div className="mt-3">
          <button
            onClick={() => setShowDetailCalcul(!showDetailCalcul)}
            className="w-full text-left px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded text-xs font-medium text-gray-700 flex justify-between items-center transition-colors"
          >
            <span>📋 Détail du calcul de l'avancée (référence admin)</span>
            <span>{showDetailCalcul ? '▼' : '▶'}</span>
          </button>
          
          {showDetailCalcul && (
            <div className="mt-2 p-3 bg-white rounded border border-gray-200 text-xs space-y-1">
              {detailCalculAvancee.map((item, index) => (
                <div
                  key={index}
                  className={`flex justify-between py-1 ${
                    item.isTotal
                      ? 'border-t-2 border-blue-300 pt-2 mt-2 font-bold text-blue-900'
                      : 'text-gray-700'
                  }`}
                >
                  <span>{item.label}</span>
                  <span className={item.isTotal ? 'text-blue-900' : 'text-gray-600'}>
                    {item.valeur > 0 ? '+' : ''}{item.valeur} cm
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      
      {/* Prix de vente */}
      {fabricCalculation.price_total && (
        <div className="mt-3 p-3 bg-green-50 rounded border border-green-200">
          <div className="flex justify-between items-center">
            <span className="text-sm font-semibold text-green-900">Prix total TTC:</span>
            <span className="text-2xl font-bold text-green-700">
              {(() => {
                const sanglonsCost = isPergola && optionsSupp.sanglons ? nombreSanglons * sanglonUnitPrice : 0;
                const totalWithOptions = fabricCalculation.price_total + sanglonsCost;
                return formatPrice(totalWithOptions);
              })()} €
            </span>
          </div>
          {isPergola && optionsSupp.sanglons && nombreSanglons > 0 && (
            <div className="mt-2 text-xs text-gray-600 space-y-1">
              <div className="flex justify-between">
                <span>Prix toile :</span>
                <span>{formatPrice(fabricCalculation.price_total)} €</span>
              </div>
              <div className="flex justify-between">
                <span>Sanglons ({nombreSanglons} × {formatUnitPrice(sanglonUnitPrice)}€) :</span>
                <span>{formatPrice(nombreSanglons * sanglonUnitPrice)} €</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FabricCalculationDisplay;